import { NavLink } from "../../../../../types/drawer/NavItem";

export const nav_links: NavLink[] = [
  { href: "/", text: "Home", icon: "Home" },
  {
    text: "Platform",
    icon: "Globe",
    href: "/walkthrough",
    children: [
      {
        category: "",
        links: [
          {
            href: "/walkthrough",
            text: "Walkthrough",
            icon: "PlayCircle",
          },
          {
            href: "/system-map",
            text: "System Map",
            icon: "Network",
          },
          {
            href: "/portal",
            text: "Architecture",
            icon: "Globe",
          },
          {
            href: "/perspectives",
            text: "Perspectives",
            icon: "Compass",
          },
        ],
      },
    ],
  },
  {
    text: "Solutions",
    icon: "Layers",
    href: "/solutions",
    children: [
      {
        category: "Intelligence",
        icon: "Brain",
        links: [
          {
            href: "/solutions/actual-intelligence",
            text: "Actual Intelligence",
            icon: "Brain",
          },
        ],
      },
      {
        category: "Coordination",
        icon: "GitBranch",
        links: [
          {
            href: "/solutions/system-bridge",
            text: "Systems Bridge",
            icon: "Repeat",
          },
          {
            href: "/solutions/automation-labs",
            text: "Managed Automation",
            icon: "Workflow",
          },
        ],
      },
      {
        category: "Operations",
        icon: "Cog",
        links: [
          {
            href: "/solutions/client-intelligence",
            text: "Client Intelligence",
            icon: "Users",
          },
          {
            href: "/solutions/vendor-ops",
            text: "Vendor Management",
            icon: "Building2",
          },
        ],
      },
      {
        category: "Support",
        icon: "LifeBuoy",
        links: [
          {
            href: "/solutions/outage-hub",
            text: "Outage Monitoring",
            icon: "AlertCircle",
          },
          {
            href: "/solutions/tech-mentor",
            text: "Tech Mentoring",
            icon: "GraduationCap",
          },
          {
            href: "/solutions/troubleshooting",
            text: "Troubleshooting",
            icon: "Wrench",
          },
        ],
      },
      {
        category: "Workforce",
        icon: "Users",
        links: [
          {
            href: "/solutions/lifecycle-navigator",
            text: "Lifecycle Manager",
            icon: "UserCog",
          },
          {
            href: "/solutions/onboarding",
            text: "Onboarding Navigator",
            icon: "UserPlus",
          },
        ],
      },
    ],
  },
  { href: "/desktop", text: "Desktop App", icon: "Monitor" },
  { href: "/integrations", text: "Integrations", icon: "LinkIcon" },
  {
    text: "Research",
    icon: "BookOpen",
    href: "/research/how-it-works",
    children: [
      {
        category: "",
        links: [
          {
            href: "/research/how-it-works",
            text: "How It Works",
            icon: "HelpCircle",
          },
          {
            href: "/research/participation",
            text: "Participation",
            icon: "UserCheck",
          },
          {
            href: "/sweepstakes",
            text: "Incentives",
            icon: "Ticket",
          },
          {
            href: "/investments",
            text: "Investor Access",
            icon: "Banknote",
          },
        ],
      },
    ],
  },
  { href: "/roadmap", text: "Roadmap", icon: "Map" },
  { href: "/feedback", text: "Feedback", icon: "MessageSquare" },
];
